import { useParams } from 'react-router-dom'
import { BackLink, Notice, Skeleton, SkeletonGroup } from '@/components/play'
import { FeedbackDetail } from '@/components/feedback/FeedbackDetail'
import { useFeedbackItem } from '@/hooks/useFeedback'

export function FeedbackDetailPage() {
  const { ticketId } = useParams<{ ticketId: string }>()
  const { item, loading, error, setItem } = useFeedbackItem(ticketId)

  return (
    <div className="min-h-screen bg-transparent">
      <div className="app-page max-w-7xl space-y-6">
        <BackLink to="/feedback">Feedback</BackLink>

        {loading ? (
          <SkeletonGroup label="Loading feedback" className="grid gap-4">
            <Skeleton shape="panel" className="h-64" />
            <Skeleton shape="panel" className="h-64" />
          </SkeletonGroup>
        ) : null}

        {error ? (
          <Notice tone="error">{error}</Notice>
        ) : null}

        {item ? <FeedbackDetail item={item} onItemChange={setItem} /> : null}
      </div>
    </div>
  )
}
